export enum IconVariants {
  fluent = 'fluent',
  png = 'png',
}
